export default __webpack_public_path__ + "8b183ccb042709658542f88e2c19a4d6.svg";